export enum LevelGroup { Event, User }
